import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { auth } from "../Firebase";

import TrippieLogo from "../../img/trippie_logo.png";
import TrippiePlane from "../../img/trippie-air-plane.svg";

// const dropdownStyles = `
//   .dropdown-container {
//     position: relative;
//   }

//   .dropdown-menu {
//     position: absolute;
//     top: 100%;
//     left: 0;
//     background: white;
//     box-shadow: 0 2px 8px rgba(0,0,0,0.1);
//     list-style: none;
//     padding: 0;
//     margin: 0;
//     min-width: 150px;
//     z-index: 1000;
//   }

//   .dropdown-link {
//     display: block;
//     padding: 10px 15px;
//     text-decoration: none;
//     color: inherit;
//   }

//   .dropdown-link:hover {
//     background-color: #f5f5f5;
//   }
// `;

function handleNavigation() {
  let menuBtn = document.getElementById("menuHamburger");
  let mobileNav = document.getElementById("nav-list");
  menuBtn.classList.contains("open")
    ? menuBtn.classList.remove("open")
    : menuBtn.classList.add("open");
  menuBtn.classList.contains("open")
    ? mobileNav.classList.add("open")
    : mobileNav.classList.remove("open");
}

export default function Navigation() {
  const [user, setUser] = useState();
  const [aboutDropdownOpen, setAboutDropdownOpen] = useState(false);
  const [signUpDropdownOpen, setSignUpDropdownOpen] = useState(false);
  const [customerDropdownOpen, setCustomerDropdownOpen] = useState(false);
  const [deliverDropdownOpen, setDeliverDropdownOpen] = useState(false);
  const [supportDropdownOpen, setSupportDropdownOpen] = useState(false);
  const [policiesDropdownOpen, setPoliciesDropdownOpen] = useState(false);


  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUser(user);
    });
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.nav-bar-list-item')) {
        setAboutDropdownOpen(false);
        setSignUpDropdownOpen(false);
        setCustomerDropdownOpen(false);
        setDeliverDropdownOpen(false);
        setSupportDropdownOpen(false);
        setPoliciesDropdownOpen(false);
      }
    };

    if (aboutDropdownOpen || signUpDropdownOpen || customerDropdownOpen || deliverDropdownOpen || supportDropdownOpen || policiesDropdownOpen ) {
      document.addEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [aboutDropdownOpen , signUpDropdownOpen, customerDropdownOpen, deliverDropdownOpen, supportDropdownOpen, policiesDropdownOpen]);

  return (
    <nav className="nav-bar">
      <div className="nav-bar-container container-middle-content">
        <NavLink className="nav-bar-personal-name fs-20" to="/">
          <div className="trippieair-logo">
            <img className="trippie-logo" src={TrippieLogo} alt="" />
            <img className="flying-plane" src={TrippiePlane} alt="" />
          </div>
        </NavLink>

        <div className="menu-btn-container">
          <div
            id="menuHamburger"
            className="menu-btn"
            onClick={handleNavigation}
          >
            <div className="menu-btn-burger"></div>
          </div>
        </div>

        <div id="nav-list" className="responsive-nav-bar">
          <ul className="nav-bar-list">
            <li className="nav-bar-list-item">
              <NavLink
                onClick={handleNavigation}
                exact
                to="/"
                className="nav-bar-link"
              >
                Home
              </NavLink>
            </li>
            <li 
  className="nav-bar-list-item" 
  style={{ position: "relative" }}
  onMouseEnter={() => setAboutDropdownOpen(true)}
  onMouseLeave={() => setAboutDropdownOpen(false)}
>
<span className="nav-bar-link" style={{ cursor: 'pointer' }}>
  About {aboutDropdownOpen ? "▲" : "▼"}
</span>
  {aboutDropdownOpen && (
    <ul
      style={{
        position: "absolute",
        top: "100%",
        left: "0",
        background: "white",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        listStyle: "none",
        padding: "0",
        margin: "0",
        minWidth: "300px",
        zIndex: "1000",
      }}
    >
      <li>
                    <NavLink
                      onClick={() => {
                        handleNavigation();
                        setAboutDropdownOpen(false);
                      }}
                      to="/about"
                      style={{
                        display: "block",
                        padding: "10px 15px",
                        textDecoration: "none",
                        color: "inherit",
                      }}
                    >
                      What is Trippie Air
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() => {
                        handleNavigation();
                        setAboutDropdownOpen(false);
                      }}
                      to="/process"
                      style={{
                        display: "block",
                        padding: "10px 15px",
                        textDecoration: "none",
                        color: "inherit",
                      }}
                    >
                      Delivery process
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() => {
                        handleNavigation();
                        setAboutDropdownOpen(false);
                      }}
                      to="/communicate"
                      style={{
                        display: "block",
                        padding: "10px 15px",
                        textDecoration: "none",
                        color: "inherit",
                      }}
                    >
                      How to communicate with the driver within the app
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() => {
                        handleNavigation();
                        setAboutDropdownOpen(false);
                      }}
                      to="/create-delivery"
                      style={{
                        display: "block",
                        padding: "10px 15px",
                        textDecoration: "none",
                        color: "inherit",
                      }}
                    >
                      How to create a delivery
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() => {
                        handleNavigation();
                        setAboutDropdownOpen(false);
                      }}
                      to="/duplicate-delivery"
                      style={{
                        display: "block",
                        padding: "10px 15px",
                        textDecoration: "none",
                        color: "inherit",
                      }}
                    >
                      How to duplicate an existing delivery
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() => {
                        handleNavigation();
                        setAboutDropdownOpen(false);
                      }}
                      to="/pay-delivery"
                      style={{
                        display: "block",
                        padding: "10px 15px",
                        textDecoration: "none",
                        color: "inherit",
                      }}
                    >
                      How to pay using your card for a delivery
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() => {
                        handleNavigation();
                        setAboutDropdownOpen(false);
                      }}
                      to="/register-company"
                      style={{
                        display: "block",
                        padding: "10px 15px",
                        textDecoration: "none",
                        color: "inherit",
                      }}
                    >
                      How to register with Trippie Air as a company
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() => {
                        handleNavigation();
                        setAboutDropdownOpen(false);
                      }}
                      to="register-customer"
                      style={{
                        display: "block",
                        padding: "10px 15px",
                        textDecoration: "none",
                        color: "inherit",
                      }}
                    >
                      How to register with Trippie Air as a customer
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() => {
                        handleNavigation();
                        setAboutDropdownOpen(false);
                      }}
                      to="/qr-code"
                      style={{
                        display: "block",
                        padding: "10px 15px",
                        textDecoration: "none",
                        color: "inherit",
                      }}
                    >
                      How to share a QR-code for your delivery request
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={() => {
                        handleNavigation();
                        setAboutDropdownOpen(false);
                      }}
                      to="/track-delivery"
                      style={{
                        display: "block",
                        padding: "10px 15px",
                        textDecoration: "none",
                        color: "inherit",
                      }}
                    >
                      How to track your delivery
                    </NavLink>
                  </li>
                </ul>
              )}
            </li>
            <li 
  className="nav-bar-list-item" 
  style={{ position: "relative" }}
  onMouseEnter={() => setPoliciesDropdownOpen(true)}
  onMouseLeave={() => setPoliciesDropdownOpen(false)}
>
  <span className="nav-bar-link" style={{ cursor: 'pointer' }}>
    Policies {policiesDropdownOpen ? "▲" : "▼"}
  </span>
  {policiesDropdownOpen && (
    <ul
      style={{
        position: "absolute",
        top: "100%",
        left: "0",
        background: "white",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        listStyle: "none",
        padding: "0",
        margin: "0",
        minWidth: "200px",
        zIndex: "1000",
      }}
    >
      <li>
        <NavLink
          onClick={() => {
            handleNavigation();
            setPoliciesDropdownOpen(false);
          }}
          to="/legal"
          style={{
            display: "block",
            padding: "10px 15px",
            textDecoration: "none",
            color: "inherit",
          }}
        >
          Terms & Conditions
        </NavLink>
      </li>
      <li>
        <NavLink
          onClick={() => {
            handleNavigation();
            setPoliciesDropdownOpen(false);
          }}
          to="/privacy"
          style={{
            display: "block",
            padding: "10px 15px",
            textDecoration: "none",
            color: "inherit",
          }}
        >
          Data and Privacy Policies
        </NavLink>
      </li>
      <li>
        <NavLink
          onClick={() => {
            handleNavigation();
            setPoliciesDropdownOpen(false);
          }}
          to="/refund"
          style={{
            display: "block",
            padding: "10px 15px",
            textDecoration: "none",
            color: "inherit",
          }}
        >
          Refund Policy
        </NavLink>
      </li>
    </ul>
  )}
</li>
            <li 
  className="nav-bar-list-item" 
  style={{ position: "relative" }}
  onMouseEnter={() => setDeliverDropdownOpen(true)}
  onMouseLeave={() => setDeliverDropdownOpen(false)}
>
  <span className="nav-bar-link" style={{ cursor: 'pointer' }}>
    Deliver with us {deliverDropdownOpen ? "▲" : "▼"}
  </span>
  {deliverDropdownOpen && (
    <ul
      style={{
        position: "absolute",
        top: "100%",
        left: "0",
        background: "white",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        listStyle: "none",
        padding: "0",
        margin: "0",
        minWidth: "250px",
        zIndex: "1000",
      }}
    >
      <li>
        <NavLink
          onClick={() => {
            handleNavigation();
            setDeliverDropdownOpen(false);
          }}
          to="/register"
          style={{
            display: "block",
            padding: "10px 15px",
            textDecoration: "none",
            color: "inherit",
          }}
        >
          Register your logistic company
        </NavLink>
      </li>
    </ul>
  )}
</li>
         <li 
  className="nav-bar-list-item" 
  style={{ position: "relative" }}
  onMouseEnter={() => setSupportDropdownOpen(true)}
  onMouseLeave={() => setSupportDropdownOpen(false)}
>
  <span className="nav-bar-link" style={{ cursor: 'pointer' }}>
    Support {supportDropdownOpen ? "▲" : "▼"}
  </span>
  {supportDropdownOpen && (
    <ul
      style={{
        position: "absolute",
        top: "100%",
        left: "0",
        background: "white",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        listStyle: "none",
        padding: "0",
        margin: "0",
        minWidth: "150px",
        zIndex: "1000",
      }}
    >
      <li>
        <NavLink
          onClick={() => {
            handleNavigation();
            setSupportDropdownOpen(false);
          }}
          to="/support"
          style={{
            display: "block",
            padding: "10px 15px",
            textDecoration: "none",
            color: "inherit",
            width: "200px",
          }}
        >
          Contact Support
        </NavLink>
      </li>
      <li>
        <NavLink
          onClick={() => {
            handleNavigation();
            setSupportDropdownOpen(false);
          }}
          to="/faqs"
          style={{
            display: "block",
            padding: "10px 15px",
            textDecoration: "none",
            color: "inherit",
          }}
        >
          FAQ's
        </NavLink>
      </li>
    </ul>
  )}
</li>
            <li 
            className="nav-bar-list-item" 
            style={{ position: "relative" }}
            onMouseEnter={() => setSignUpDropdownOpen(true)}
            onMouseLeave={() => setSignUpDropdownOpen(false)}
          >
            <span className="nav-bar-link" style={{ cursor: 'pointer' }}>
              Sign Up 
              {/* {signUpDropdownOpen ? "▲" : "▼"} */}
            </span>
            {signUpDropdownOpen && (
              <ul
                style={{
                  position: "absolute",
                  top: "100%",
                  left: "0",
                  background: "white",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  listStyle: "none",
                  padding: "0",
                  margin: "0",
                  minWidth: "200px",
                  zIndex: "1000",
                }}
              >
          <li>
          <span
  style={{
    display: "block",
    padding: "10px 15px",
    textDecoration: "none",
    color: "inherit",
    cursor: "pointer",
    backgroundColor: "#FFF",
  }}
  onClick={() => setCustomerDropdownOpen(!customerDropdownOpen)}
  onMouseEnter={(e) => e.target.style.backgroundColor = "#FFF"}
  onMouseLeave={(e) => e.target.style.backgroundColor = "#FFF"} 
>
  Customer {customerDropdownOpen ? "▲" : "▼"}
</span>
            {customerDropdownOpen && (
              <>
                <li style={{ paddingLeft: "20px", backgroundColor: "#FFF",marginBottom: "10px" }}>
                  <NavLink
                    onClick={() => {
                      handleNavigation();
                      setSignUpDropdownOpen(false);
                      setCustomerDropdownOpen(false);
                    }}
                    to="/signup/customer/business"
                    style={{
                      display: "block",
                      padding: "10px 15px",
                      textDecoration: "none",
                      color: "inherit",
                  
                    }}
                  >
                    Business
                  </NavLink>
                </li>
                <li style={{ paddingLeft: "20px", backgroundColor: "#FFF",marginBottom: "10px" }}>
                  <NavLink
                    onClick={() => {
                      handleNavigation();
                      setSignUpDropdownOpen(false);
                      setCustomerDropdownOpen(false);
                    }}
                    to="/signup/customer/individual"
                    style={{
                      display: "block",
                      padding: "10px 15px",
                      textDecoration: "none",
                      color: "inherit",
                    }}
                  >
                    Individual
                  </NavLink>
                </li>
              </>
            )}
          </li>
                <li>
                  <NavLink
                    onClick={() => {
                      handleNavigation();
                      setSignUpDropdownOpen(false);
                    }}
                    to="/signup/driver"
                    style={{
                      display: "block",
                      padding: "10px 15px",
                      textDecoration: "none",
                      color: "inherit",
                    }}
                  >
                    Driver
                  </NavLink>
                </li>
    </ul>
  )}
</li>

            {user ? (
              <li className="nav-bar-list-item">
                <div className="logout-btn" onClick={() => auth.signOut()}>
                  Sign Out
                </div>
              </li>
            ) : (
              <></>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}
